/**
 * url 을 받아 remove patterns 를 제거한 url 을 반환
 * @param url
 * @param removePatterns
 * @returns {string}
 */
export const removeUrlPatterns = (url = '', removePatterns = []) => {
  removePatterns.forEach((pattern) => {
    url = url.replace(pattern, '')
  })

  return url
}
